import {StructuredDataContent} from 'rlink-repos/content';

export class Article extends StructuredDataContent {
  static get contentIcon () {
    return 'newspaper-o';
  }

  imageFormats () {
    return [this.bannerImageFormats];
  }

  get articleType () {
    return this.data.get('articleType', '');
  }

  get title () {
    return this.data.get('title', '');
  }

  get body () {
    return this.data.get('body', '');
  }

  get bannerImageFormats () {
    return {
      src: this.bannerPath,
      formats: [
        {contentType: 'image/webp', fileExt: 'webp'},
        {contentType: 'image/jpeg', fileExt: 'jpg'},
      ],
      widths: [
        2560, 1920, 1680, 1366, 1024, 800, 568, 480, 420, 320,
      ],
    };
  }

  get bannerPath () {
    return this.data.get('bannerPath', '');
  }

  get authorPath () {
    return this.data.get('authorPath');
  }

  get introduction () {
    return this.data.get('introduction', '');
  }

  get slug () {
    return this.data.get('slug', '');
  }

  get isExternal () {
    return this.data.get('isExternal', false);
  }

  get externalUrl () {
    return this.data.get('externalUrl', '');
  }

  //@TODO: delete me
  urlSlug () {
    return this.title.replace(/[^a-zA-Z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  get publishedOn () {
    return new Date(this.data.get('publishedOn'));
  }

  get adminLabel () {
    return ('title' in this) && this.title.length > 0 ? this.title : '<blank article>';
  }

  embeddedContentPaths () {
    let reTags = /<img.*?src=(["'])(.*?)\1.*?>/gi;
    let match;
    let paths = [];
    while (match = reTags.exec(this.body)) {
      paths.push(match[2]);
    }
    return paths;
  }

  get linkedContentPaths () {
    return this.embeddedContentPaths().concat([this.bannerPath, this.authorPath]);
  }

  summary (length, ellideUsing = ' ...') {
    if (this.body.length > length - ellideUsing.length) {
      return this.body.slice(0, length - ellideUsing.length) + ellideUsing;
    } else {
      return this.body;
    }

  }
}

Article.translatedAttributes = {
  title: {
    path: ['title'],
    description: 'A blog post\'s article title.',
  },
  introduction: {
    path: ['introduction'],
    description: 'A blog post\'s summary blurb.',
  },
  body: {
    path: ['body'],
    description: 'A blog post\'s article text.',
  },
};


export class Author extends StructuredDataContent {
  static get contentIcon () {
    return 'user';
  }
  get name () {
    return this.data.get('name');
  }
  get forumsProfile () {
    return this.data.get('forumsProfile');
  }
  get forumsLink () {
    return this.data.get('forumsLink');
  }
  get adminLabel () {
    return this.name || '<anonymous author>';
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-blog/index.js